import * as React from 'react';

import { Modal } from 'antd';

export interface ConfirmationModalProps extends React.PropsWithChildren<{}> {
  cancelText?: string;
  className?: string;
  isLoading?: boolean;
  okText?: string;
  onCancel: () => void;
  onOk: () => void;
  title?: string;
  visible: boolean;
  width?: number;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  cancelText,
  children,
  className,
  isLoading,
  okText,
  onCancel,
  onOk,
  title,
  visible,
  width,
}) => {
  return (
    <Modal
      centered
      cancelText={cancelText}
      className={className}
      loading={isLoading}
      okText={okText}
      open={visible}
      title={title || 'Are you sure?'}
      width={width || 550}
      onCancel={onCancel}
      onOk={onOk}
    >
      {children}
    </Modal>
  );
};

export default ConfirmationModal;
